import { Currency } from '../pricing/pricing.types';

export enum BillingPlanTier {
  Launch = 'launch',
  Scale = 'scale',
  Lead = 'lead',
}

export type BillingPeriod = 1 | 3 | 6 | 12 | 24 | 36;

export type BillingPlan = {
  id: number;
  basePrice?: number;
  baseSlots: number;
  billingPeriod: BillingPeriod;
  tier: BillingPlanTier;
  currency: Currency;
  pricing: Partial<
    Record<BillingPeriod, { slotPrice: number; basePrice: number; textingPrice: number }>
  >;
  createdAt: number;
  custom: boolean;
  unlimited: boolean;
};
